import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-furnitureshop-grid-slider.js';

const images = [
  'https://cdn.skyfastimg.com/images/2026/08/20/image-6a86a700aa77a241c2ecbb30.webp?w=1000',
  'https://cdn.skyfastimg.com/images/2026/08/20/image-6a86a6728e6c6176be620c28.webp?w=1000',
  'https://cdn.skyfastimg.com/images/2026/08/20/image-6a86a69ddf216b02da5a2b41.webp?w=1000',
  'https://cdn.skyfastimg.com/images/2026/08/20/image-6a86a7ac46f400a3618acadf.webp?w=1000',
  'https://cdn.skyfastimg.com/images/2026/08/20/image-6a86a62e46904c8290739a1b.webp?w=1000',
  'https://cdn.skyfastimg.com/images/2026/08/20/image-6a86a717e414632304b03b4b.webp?w=1000',
];
const items = [
  { image: 'https://cdn.skyfastimg.com/images/2026/08/20/image-6a86a73c08c49d9f036a7b84.webp?w=500', text: 'Gloss' },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/08/20/image-6a86a746266e9546bcabf16a.webp?w=500',
    text: 'Durability',
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/08/20/image-6a86a75138e601390b7a374b.webp?w=500',
    text: 'Protection',
  },
];

const renderImage = image => `
  <img
    class="furnitureshop-grid-slider__image"
    data-attribute="furnitureshop-grid-slider__image"
    src="${image}"
    alt=""
  />
`;

const renderSlides = list => {
  const slides = [];
  for (let index = 0; index < list.length; index += 2) {
    slides.push(`
      <div class="swiper-slide" data-attribute="furnitureshop-grid-slider__slide">
        <div class="furnitureshop-grid-slider__image-grid">
          ${list
            .slice(index, index + 2)
            .map(renderImage)
            .join('\n')}
        </div>
      </div>
    `);
  }
  return slides.join('\n');
};

const renderItem = item => `
  <div class="furnitureshop-grid-slider__item" data-attribute="furnitureshop-grid-slider__item">
    <img
      class="furnitureshop-grid-slider__item-image"
      data-attribute="furnitureshop-grid-slider__item-image"
      src="${item.image}"
      alt=""
    />
    <span data-attribute="furnitureshop-grid-slider__item-text">${item.text}</span>
  </div>
`;

const contentHtml = `
  <div class="furnitureshop-grid-slider container" data-attribute="furnitureshop-grid-slider">
    <div class="furnitureshop-grid-slider__carousel">
      <div class="swiper furnitureshop-grid-slider__swiper">
        <div class="swiper-wrapper" data-attribute="furnitureshop-grid-slider__list">
          ${renderSlides(images)}
        </div>
      </div>
      <button
        type="button"
        class="furnitureshop-grid-slider__navigation furnitureshop-grid-slider__navigation--prev"
        aria-label="Previous slide"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6" /></svg>
      </button>
      <button
        type="button"
        class="furnitureshop-grid-slider__navigation furnitureshop-grid-slider__navigation--next"
        aria-label="Next slide"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6" /></svg>
      </button>
    </div>
    <div class="furnitureshop-grid-slider__pagination"></div>
    <div class="furnitureshop-grid-slider__items" data-attribute="furnitureshop-grid-slider__items">
      ${items.map(renderItem).join('\n')}
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#181818',
  textColor: '#FFFFFF',
});
